import React from 'react';
import '../../componentsStyling/Footer.css';

function Footer() {

    return (
        <header className="footer">
        </header>
    );
}

export default Footer;